import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '../../core/user/user.service';
import { SessionService } from '../../core/session.service';

@Component({
    selector: 'rosie-trial-plans-selection',
    templateUrl: './trial-plans-selection.component.html',
    styleUrls: ['./trial-plans-selection.component.scss'],
    standalone: false
})
export class TrialPlansSelectionComponent {
    @Output() launchInstructionsClicked = new EventEmitter<void>();

    constructor(
        private user: UserService,
        private session: SessionService
    ) { }

    get hasTrialExpired(): boolean {
        return this.user.hasTrialExpired;
    }

    get isMobileVersion(): boolean {
        return this.session.isMobileVersion;
    }

    get isOnLegacyUnlimitedMinutes(): boolean {
        return !this.user.isUserOnBillingV4;
    }

    navigateToLaunchInstructions(): void {
        this.launchInstructionsClicked.emit();
    }
}

